import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dismissExpiredSelectionWarnings, refreshSelectionDeadlines } from '../../model/configuratorSlice';
import { formatDeadline } from '../../utilities/SelectionDeadlineUtility';

const ExpiredSelectionsPopup = () => {
  const dispatch = useDispatch();
  const notices = useSelector(state => state.configurator.expiredSelectionWarnings) || [];
  const promotionExpired = useSelector(state => state.configurator.isPromotionExpired);
  const accept = useRef(null);
  const opened = notices.length > 0 && !promotionExpired;
  useEffect(() => {
    const refresh = () => dispatch(refreshSelectionDeadlines());
    const timer = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    return () => { clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [dispatch]);
  useEffect(() => {
    if (!opened) return undefined;
    const previous = document.activeElement;
    accept.current?.focus();
    const handleKey = (event) => {
      if (event.key === 'Escape') dispatch(dismissExpiredSelectionWarnings());
      if (event.key === 'Tab') { event.preventDefault(); accept.current?.focus(); }
    };
    document.addEventListener('keydown', handleKey);
    return () => { document.removeEventListener('keydown', handleKey); previous?.focus?.(); };
  }, [opened, dispatch]);
  if (!opened) return null;
  const close = () => dispatch(dismissExpiredSelectionWarnings());
  return (
    <div className="save-config-popup opened" style={{ zIndex: 3000 }}>
      <div className="background opened" />
      <div
        className="panel opened"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="expiry-title"
        aria-describedby="expiry-description"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'min(610px, calc(100vw - 32px))',
          height: 'auto',
          maxHeight: '90vh',
          overflowY: 'auto',
          boxSizing: 'border-box',
          padding: 24,
        }}
      >
        <div id="expiry-title" className="header" style={{ paddingTop: 0 }}>Opciones fuera de plazo</div>
        <p id="expiry-description">
          Estas opciones ya no están disponibles y se han desmarcado. Revisa la configuración antes de guardarla.
        </p>
        <ul style={{ alignSelf: 'stretch', paddingLeft: 24 }}>
          {notices.map(item => (
            <li key={`${item.category_id}:${item.feature_id}`}>
              {item.room_name ? `${item.room_name} · ` : ''}{item.name}
              {item.selection_deadline ? ` — Plazo finalizado: ${formatDeadline(item.selection_deadline)}` : ''}
            </li>
          ))}
        </ul>
        <div className="container-buttons">
          <button ref={accept} className="logout-button" type="button" onClick={close}>Aceptar</button>
        </div>
      </div>
    </div>
  );
};
export default ExpiredSelectionsPopup;
